import React from 'react';
import Breadcrumb from './Breadcrumb';

const PageHero = ({ title, breadcrumbItems, subtitle }) => {
  return (
    <section className="page-hero">
      <div className="page-hero-background"></div>
      <div className="page-hero-container">
        <Breadcrumb items={breadcrumbItems} />
        <h1 className="page-hero-title fade-in-up">{title}</h1>
        {subtitle && <p className="page-hero-subtitle fade-in-up delay-1">{subtitle}</p>}
      </div>
    </section>
  );
};

export default PageHero;
